import { useMyContext } from 'Context/MyContextProvider';
const PermissionChecker = ({ permission, children }) => {
    const { Permisson } = useMyContext();
    const hasPermission = () => {
        return Permisson?.includes(permission);
    }
    
    if (hasPermission()) {
        return children;
    }
    
    return null;
}

export default PermissionChecker
